import React, { useState } from 'react';
import FloatInput from 'components/generic-components/FloatInput';
import { CameraIconPlus, CloseModalIcon, PaymentIcon, FilledCardIcon, CardIcon, FiiledPaymentIcon, NewBackIcon } from 'components/Icons';
import CustomButton from 'components/generic-components/ButtonComponent';
import UnregisteredLayout from './UnregisteredLayout';
import RegisteredLaouyt from './RegisteredLaouyt';
import SelectModal from 'components/SelectModal';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import API from '../../../../API';
import { registeredCard, paymentHistory } from '../../../../reducers/feed/feed.actions';
import { deleteCard } from '../../../../reducers/feed/feed.actions';
import { useDispatch } from 'react-redux';
import Loader from '../../../../components/Loader';
import { Link, useLocation } from 'react-router-dom';
import { fetchCreditCards, getCurrentUser, getNotifications } from '../../../../reducers/auth/auth.actions';

import PostActionItem from '../../../../components/generic-components/post/PostActionItem';
import { PAYMENTS, ROOT } from 'constants/routes';
import { useHistory } from 'react-router-dom';
import CardLogos from './CardLogos';

const AddCard = () => {
  const [payment, setPay] = useState(true);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [card, setCard] = useState(null);
  const [isSubmitting, setisSubmiting] = useState(true);
  const [isPaymentHistory, setPaymentHistory] = useState(null);
  const history = useHistory();
  const [paymentLoading, setPaymentLoading] = React.useState(false)
  const [cardUser, setCardUser] = useState(false);
  const [changePop, setchangePop] = useState(false)

  const toggleView = () => {
    setPay(!payment)
  }
  const deleteRegisteredCard = () => {
    dispatch(deleteCard()).then(resp => window.location.reload())
    setPaymentLoading(true)
  }
  React.useEffect(() => {

    dispatch(getCurrentUser()).then(
      (resp) => { setCardUser(resp) }
    );

    setisSubmiting(true)
    dispatch(registeredCard()).then(
      (resp) => {
        if (resp) {

          setCard(resp)
          setisSubmiting(false)

        }
      }
    )
    dispatch(paymentHistory()).then(
      (resp) => {
        if (resp) {

          setPaymentHistory(resp)

        }
      }
    )

  }, []);
  return (
    <div>
      <div className="add-card-header header">

        <div className="d-flex justify-content-between align-items-center offset-side-menu header-content">
          <div className="card-back-btn d-flex align-items-center p-3" >
            <div className='hebrew-back' onClick={() => history.push(ROOT)}  >

              <NewBackIcon />
            </div>
            <div className="custom-title-container pl-4 ">{t(`Payments`)}</div></div>
          <div  >
            <div className="d-flex px-3" >
              {
                card && card.length != 0 ?
                  <div onClick={() => { setchangePop(true) }}
                    className={"change-card-btn card-btn"} >{t(`Change card`)}
                  </div>

                  :

                  <Link to={PAYMENTS}
                    className={"card-btn"} >{t(`Add card`)}
                  </Link>
              }
            </div>
          </div>
        </div>
      </div>


      <div className={'payments-container'} >
        <div className={paymentLoading && 'card-loader'}>
          <Loader isLoadin={paymentLoading} height={280} size={60} >

          </Loader>
        </div>
        <div className={'payments-header-action d-flex'}>
          <div onClick={() => toggleView()}>
            <PostActionItem
              icon={payment ? FilledCardIcon : CardIcon}
              customClass={payment ? 'card-view' : ''}

            />
          </div>
          <div onClick={() => toggleView()}>
            <PostActionItem
              icon={!payment ? FiiledPaymentIcon : PaymentIcon}
              customClass={!payment ? 'card-view' : ''}

            />
          </div>
        </div>
        <div className="payment-content">
          <Loader isLoadin={isSubmitting} height={280} size={60}>
            {
              card && card.length != 0 ?
                <RegisteredLaouyt cardUser={cardUser} isPaymentHistory={isPaymentHistory} view={payment} cardinfo={card} deleteCard={deleteRegisteredCard} />
                : <UnregisteredLayout isPaymentHistory={isPaymentHistory} view={payment} />

            }
            {changePop &&
              <div className="card-popup-wrapper">
                <div className="card-popup">
                  <div className="change-popup">
                    <h2>{t(`Change card`)}</h2>
                    <p>{t(`Are you sure?`)}</p>
                    <div className="popup-footer">
                      <a onClick={() => { setchangePop(false) }} className="cancel-btn">{t(`Cancel`)}
                      </a>
                      <Link to={PAYMENTS} className="change-btn">{t(`Change card`)}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            }
            <CardLogos />
          </Loader>

        </div>
      </div>
    </div>
  );
};

export default AddCard;
